<script>
import SetDetailsCircuit from '@components/circuit/set-details-circuit.vue';

export default {
  components: {
    SetDetailsCircuit,
  },
  props: {
    circuit: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
};
</script>

<template>
  <div class="card-circuit-container">
    <div class="card-circuit-header">
      <h2>{{ circuit.label }}</h2>
      <div>
        <h1 class="rep-num">
          <small>x</small>
          <span>{{ circuit.circuitReps }}</span>
        </h1>
      </div>
    </div>
    <div class="card-circuit-content">
      <SetDetailsCircuit v-for="(exercise, i) in circuit.exercises" :key="i" :exercise="exercise" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-circuit-container {
  background-color: white;
  border-radius: $base-border-radius-lg;
  box-shadow: 0 0.2rem 0.4rem rgba(black, 0.08);
  margin: 1.6rem;
  margin-bottom: 3.2rem;
  transition: transform 300ms;
  transition-timing-function: ease-out;

  &:hover {
    box-shadow: 0 0.4rem 0.8rem rgba(black, 0.1);
    transform: scale(1.005);
  }

  .card-circuit-header {
    align-items: center;
    border-bottom: 4px solid $color-card-circuit-header-border;
    display: flex;
    justify-content: space-between;
    min-height: 9rem;
    padding: 1.5rem 2.5rem;

    h2 {
      font-family: $base-font-family;
      margin-bottom: 0;
      margin-right: 3rem;
    }
    .rep-num {
      color: $color-text;
      font-family: $base-font-family;
      font-size: 3.2rem;
      margin: 0 2rem;
      overflow: hidden;

      small {
        font-weight: 800;
        margin-right: 0.5rem;
      }
    }
  }

  .card-circuit-content {
    min-height: 22.6rem;
  }
}
</style>
